<template>
  <div>
    <div class="form-group row mb-10">
      <label class="col-2 form-control-label pt-0"><span :class="{ ess: markRequired }">건설기계등록증</span></label>
      <div class="col-10">
        <label class="md-check mr-20"><input type="radio" v-model="equip.hasCertificate" :value="true"><i class="blue"></i>유</label>
        <label class="md-check mr-20"><input type="radio" v-model="equip.hasCertificate" :value="false"><i class="blue"></i>무</label>
      </div>
    </div>
    <div class="form-group row mb-10">
      <label class="col-2 form-control-label pt-0"><span :class="{ ess: markRequired }">장비명(모델명)</span></label>
      <div class="col-4"><input type="text" class="form-control" v-model="equip.modelName" :placeholder="placeholders.modelName || ''"></div>
      <label class="col-2 form-control-label pt-0">제조사</label>
      <div class="col-4"><input type="text" class="form-control" v-model="equip.manufacturer" :placeholder="placeholders.manufacturer || ''"></div>
    </div>
    <div class="form-group row mb-10">
      <label class="col-2 form-control-label pt-0"><span :class="{ ess: markRequired && registrationNoRequired }">등록번호</span></label>
      <div class="col-4"><input type="text" class="form-control" v-model="equip.registrationNo" :placeholder="placeholders.registrationNo || ''"></div>
      <label class="col-2 form-control-label pt-0">제작연도</label>
      <div class="col-4" :style="yearSuffix ? 'display:flex;align-items:center;gap:6px;' : ''">
        <input type="text" class="form-control" v-model="equip.manufactureYear" :placeholder="placeholders.manufactureYear || ''">
        <span v-if="yearSuffix">년</span>
      </div>
    </div>
    <div class="form-group row mb-10">
      <label class="col-2 form-control-label pt-0"><span :class="{ ess: markRequired }">보험여부</span></label>
      <div class="col-10" style="display:flex;align-items:center;">
        <label class="md-check mr-20"><input type="radio" v-model="equip.insuranceStatus" value="가입"><i class="blue"></i>가입</label>
        <label class="md-check mr-20"><input type="radio" v-model="equip.insuranceStatus" value="미가입"><i class="blue"></i>미가입</label>
        <input v-if="equip.insuranceStatus === '가입'" type="text" class="form-control"
               v-model="equip.insuranceName" :placeholder="placeholders.insuranceName || '보험사명'" style="max-width:200px;">
      </div>
    </div>
    <div class="form-group row mb-10" v-if="equip.insuranceStatus === '가입'">
      <label class="col-2 form-control-label pt-0">보험 유효기간</label>
      <div class="col-4">
        <DatePicker class="form-control" type="date" :append-to-body="true"
          v-model="equip.insuranceExpiry"
          value-type="format" format="YYYY-MM-DD"
          :clearable="false" :editable="false"
          style="font-size: 12px; width: 100%;"
          input-class="calendar-input">
          <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
        </DatePicker>
      </div>
    </div>
    <div class="form-group row mb-10">
      <label class="col-2 form-control-label pt-0">정기검사일</label>
      <div class="col-4">
        <DatePicker class="form-control" type="date" :append-to-body="true"
          v-model="equip.regularInspectionDate"
          value-type="format" format="YYYY-MM-DD"
          :clearable="false" :editable="false"
          style="font-size: 12px; width: 100%;"
          input-class="calendar-input">
          <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
        </DatePicker>
      </div>
      <label class="col-2 form-control-label pt-0">검사 유효기간</label>
      <div class="col-4">
        <DatePicker class="form-control" type="date" :append-to-body="true"
          v-model="equip.inspectionExpiry"
          value-type="format" format="YYYY-MM-DD"
          :clearable="false" :editable="false"
          style="font-size: 12px; width: 100%;"
          input-class="calendar-input">
          <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
        </DatePicker>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'EquipCommonFields',
  props: {
    equip: { type: Object, required: true },
    placeholders: { type: Object, default: () => ({}) },
    yearSuffix: { type: Boolean, default: false },
    markRequired: { type: Boolean, default: false },
    // markRequired 시 등록번호도 기본 필수 표시. 등록번호가 필수 아닌 양식은 false 로 끈다.
    registrationNoRequired: { type: Boolean, default: true }
  }
}
</script>